var React = require('react');

function TagNew (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"tag_new","d":"M9,11.3,12.71,14,11.29,9.64,15,7H10.45L9,2.5,7.55,7H3L6.71,9.64,5.29,14Z","transform":"translate(-3 -2.5)","fill":"#fff"}));
}

TagNew.defaultProps = {"width":"12","height":"11.5","viewBox":"0 0 12 11.5"};

module.exports = TagNew;

TagNew.default = TagNew;
